
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/images",
      function () {
        return require("private-next-pages/components/images.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/images"])
      });
    }
  